module.exports = __webpack_public_path__ + "static/media/TrayUpper.6b647589.svg";